/** @jsxImportSource @emotion/react */

import Image from 'next/image';

import { media } from '@stories/theming/settings';
import imageLoader from '@utils/imageLoader';

import { SectionHeader, headlines, section } from './VitafyAboutUsPage';

export const processItems = [
  {
    imagePath: '/vitafy/about-us/entwicklung.png',
    title: 'Entwicklung',
    copy: 'Unsere Produktmanager entwickeln hochwertige Rezepturen. '
  },
  {
    imagePath: '/vitafy/about-us/production.png',
    title: 'Produktion',
    copy: 'Wir kaufen die entsprechenden Zutaten ein und stellen das Produkt her. '
  },
  {
    imagePath: '/vitafy/about-us/online.png',
    title: 'Online Shop',
    copy: 'Unsere Kunden kaufen ihre ausgewählten Produkte sicher in unserem Online Shop ein.'
  },
  {
    imagePath: '/vitafy/about-us/vertrieb.png',
    title: 'Vertrieb',
    copy: 'Die bestellte Ware wird umgehend verpackt und an unseren Kunden versendet. '
  }
];

export const process3rdItems = [
  {
    imagePath: '/vitafy/about-us/ankauf.png',
    title: 'Ankauf',
    copy: 'Wir scouten täglich die besten Produkte im Markt, kaufen diese günstig ein und stellen sie unseren Kunden in unserem Shop zur Verfügung.'
  },
  {
    imagePath: '/vitafy/about-us/online.png',
    title: 'Online Shop',
    copy: 'Unsere Kunden kaufen ihre ausgewählten Produkte sicher in unserem Online Shop ein.'
  },
  {
    imagePath: '/vitafy/about-us/vertrieb.png',
    title: 'Vertrieb',
    copy: 'Die bestellte Ware wird umgehend verpackt und an unseren Kunden versendet. '
  }
];

type ProcessItemProps = {
  imagePath: string;
  title: string;
  copy: string;
};

export const ProcessItem: React.FC<ProcessItemProps> = ({ imagePath, title, copy }) => {
  return (
    <div
      css={{
        background: 'linear-gradient(#F7FCFF 0%, #BACAD1 100%)',
        padding: '1.5rem 2.25rem 2.25rem',
        marginBottom: '2rem',
        textAlign: 'center',
        [media('tablet')]: { flex: '0 0 calc(50% - 1rem)', margin: '.5rem' },
        [media('desktop')]: { flex: '0 0 calc(25% - 1rem)' }
      }}
    >
      <div css={{ aspectRatio: '1', position: 'relative' }}>
        <Image
          loader={imageLoader}
          fill
          sizes="(min-width: 1200px) 300px,(min-width: 768px) 50vw ,100vw"
          src={imagePath}
          alt={title}
        />
      </div>
      <h3 css={{ ...headlines.h4, marginTop: '3rem' }}>{title}</h3>
      <p css={{ marginTop: '2rem', lineHeight: '1.5', padding: '0 1rem' }}>{copy}</p>
    </div>
  );
};

export const Process: React.FC = () => {
  return (
    <section css={{ backgroundColor: '#D5E0E5', paddingBottom: '5rem' }}>
      <svg
        viewBox="0 0 100 11"
        xmlns="http://www.w3.org/2000/svg"
        css={{ display: 'block', height: 'auto', width: '100%' }}
      >
        <path d="M0 0 L100 0 L50 11 Z" fill="hsl(198 42% 95%)" />
      </svg>
      <article css={{ paddingTop: '5rem' }}>
        <SectionHeader title="Prozess" subtitle="<p>So entstehen unsere Eigenmarken</p>" />
        <div css={{ ...section, [media('desktop')]: { padding: '0 var(--offset)' } }}>
          <div
            css={{
              [media('tablet')]: { display: 'flex', flexWrap: 'wrap', margin: '1rem .5rem' },
              [media('desktop')]: { flexWrap: 'nowrap' }
            }}
          >
            {processItems.map((item) => (
              <ProcessItem key={item.title} {...item} />
            ))}
          </div>
        </div>
      </article>
      <article css={{ marginTop: '2rem', [media('desktop')]: { marginTop: '8rem' } }}>
        <SectionHeader title="Prozess" subtitle="<p>Prozess unserer Drittmarken</p>" />
        <div css={{ ...section, [media('desktop')]: { padding: '0 var(--offset)' } }}>
          <div
            css={{
              [media('tablet')]: { display: 'flex', flexWrap: 'wrap', margin: '1rem .5rem' },
              [media('desktop')]: { flexWrap: 'nowrap', justifyContent: 'center' }
            }}
          >
            {process3rdItems.map((item) => (
              <ProcessItem key={item.title} {...item} />
            ))}
          </div>
        </div>
      </article>
    </section>
  );
};
